import { SabrePassenger } from './parseSabreGDS';

/**
 * Matches a Sabre passenger to a business employee by comparing first and last names.
 * Matching is case-insensitive and trims whitespace.
 *
 * @param passenger - The passenger from Sabre GDS data
 * @param employees - Array of business employees to search
 * @returns The matched employee or null if no match found
 */
export function getEmployeeFromSabrePassenger(
  passenger: SabrePassenger,
  employees: Array<App.BusinessEmployee>,
): App.BusinessEmployee | null {
  if (!employees || employees.length === 0) {
    return null;
  }

  const passengerFirstName = passenger.firstName.toLowerCase().trim();
  const passengerLastName = passenger.lastName.toLowerCase().trim();

  const matchedEmployee = employees.find((emp) => {
    const empFirstName = emp.firstName.toLowerCase().trim();
    const empLastName = emp.lastName.toLowerCase().trim();
    return empFirstName === passengerFirstName && empLastName === passengerLastName;
  });

  return matchedEmployee ?? null;
}
